



























































































































































import { Component, Vue } from "vue-property-decorator";
import MovingDetail from "@/components/contract-moving/movingDetail.vue";
import User, { USER_ROLE } from "@/model/user";
import { namespace } from "vuex-class";
import Company from "@/model/company";
import QUserSelect from "@/common/qUserSelect.vue";
import QWitnessSelect from "@/common/qWitnessSelect.vue";
import QErrors from "@/common/qErrors.vue";
import QCalendar from "@/common/qCalendar.vue";
import ContractMoveOut, { CONTRACT_STEP } from "@/model/contractMoveOut";
import qNotify from "@/common/qNotify";
import _ from "lodash";
import {compareWithKeys} from "@/common/utils";

const auth = namespace("Auth");
const moveOutStore = namespace("MoveOut");
const routerStore = namespace("Router");
@Component({
  name: "StepSchedule",
  components: {
    MovingDetail,
    QUserSelect,
    QWitnessSelect,
    QErrors,
    QCalendar,
  },
})
export default class StepSchedule extends Vue {
  @auth.Getter
  getCurrentyCompany!: Company;
  @auth.Getter
  getUserLogging!: User;
  @moveOutStore.Getter
  getMoveOut!: ContractMoveOut;
  @routerStore.Getter
  public getSearchParameters!:any;

  public moveOutObject: ContractMoveOut = new ContractMoveOut();
  public moveOutObjectInit: ContractMoveOut = new ContractMoveOut();

  public userRole = USER_ROLE;
  public showPopup = false;
  public errors = {};
  public dateConfig = {
    enableTime: true,
    dateFormat: "Y-m-d H:i",
    minDate: null,
    maxDate: null,
  };
  public desired_date = null;
  public selected = null;

  async mounted() {
    this.moveOutObject = new ContractMoveOut(this.getMoveOut);
    this.moveOutObject.in_charge_id = this.getUserLogging.id;
    this.dateConfig.minDate = new Date();
    this.dateConfig.maxDate = this.moveOutObject.moving_out_date;
    this.moveOutObjectInit = _.cloneDeep(this.moveOutObject)
  }

  get companyId() {
    return this.getCurrentyCompany.id;
  }

  public cancel() {
    if (this.isChanged()) {
      this.$modal.showCancel({
        text: this.$t("cancel"),
        // we are passing callback method for our confirm button
        onConfirm: () => {
          this.$router.push({ name: "admin.contract-moving" , query: this.getSearchParameters ? this.getSearchParameters.contractMovingList : null });
        },
      });
    } else {
      this.$router.push({ name: "admin.contract-moving" , query: this.getSearchParameters ? this.getSearchParameters.contractMovingList : null });
    }
  }

  public selection(index) {
    return this.selected == index ? "select" : "";
  }

  public save() {
    this.$modal.show({
      title: "日程・担当業者・担当者を確定しました。",
      text: `日程調整お疲れ様でした。<br>
      ご契約者様・立会業者担当者様・オーナー様・管理会社担当者様へ立会日程のご案内を送信します。`,
      confirmClass: "mb__button mb__w-100pc mb__add-color-green",
      cancelClass: "mb__button mb__w-100pc mb__add-color-gray",
      confirmText: "はい",
      type: "",
      // we are passing callback method for our confirm button
      onConfirm: async () => {
        // this.$router.back();
        this.submit();
      },
    });
  }

  public reject() {
    this.$modal.showCancel({
      title: "申請受理へステップを戻ります",
      text: `立会日程をリセットし、申請受理ステップへ戻ります。<br>
        この操作は取り消せません。`,
      confirmText: "はい",
      cancelText: "キャンセル",
      confirmClass: "mb__button mb__w-100pc mb__add-color-red",
      cancelClass: "mb__button mb__w-100pc mb__add-color-gray",
      type: "error",
      // we are passing callback method for our confirm button
      onConfirm: async () => {
        // this.$router.back();
        const result = await this.moveOutObject.goBack({
          step: CONTRACT_STEP.STEP_ACCEPTED,
        });
        if (result.meta.status === 200) {
          // return
          qNotify.success({
            text: this.$t("contractMoveOuts.go_back"),
          });
          this.$router.push({
            name: "admin.contract-moving",
          });
        } else {
          qNotify.error({
            text: result.meta.message,
          });
          this.errors = result.meta.errors;
        }
      },
    });
  }

  public async submit() {
    if (this.selected == 4) {
      this.moveOutObject.desired_date = this.desired_date;
    } else {
      this.moveOutObject.desired_date =
        this.moveOutObject["desired_date_" + this.selected];
    }
    const result = await this.moveOutObject.schedule();
    if (result.meta.status === 200) {
      // return
      qNotify.success({
        text: this.$t("contractMoveOuts.success_step_2"),
      });
      this.$router.push({ name: "admin.contract-moving" , query: this.getSearchParameters ? this.getSearchParameters.contractMovingList : null });
    } else {
      qNotify.error({
        text: result.meta.message,
      });
      this.errors = result.meta.errors;
    }
  }

  public isChanged() {
    if (this.selected !== null) {
      return true;
    }

    return compareWithKeys(this.moveOutObject, this.moveOutObjectInit, [
      'in_charge_id',
      'witness_id',
    ])
  }
}
